module.exports = __webpack_public_path__ + "img/bg.79205c8e.png";